import { useEffect, useState } from "react";
import {
  getCurrentReservations,
  UserReservationResponse,
} from "../../../../../api/reservation";
import {
  MyReservationListItem,
  MyReservationListItemBottom,
  MyReservationListWrapper,
} from "./styled";
import { getCompanyCurrentReservations } from "../../../../../api/reservation-company";
import { Reservation } from "../../../CompanyReservation/types";
import { PubTournament } from "../../../../../api/types";
import { useHistory } from "react-router-dom";

interface MyReservationListProps {
  list: UserReservationResponse[];
  setCancelItem: (value: UserReservationResponse) => void;
  setCurrentList: (value: Reservation[]) => void;
  setCurrentOpen: (value: boolean) => void;
  setIsCancel: (value: boolean) => void;
  getList: () => void;
}
const MyReservationList = ({
  list,
  setCurrentList,
  setCurrentOpen,
  setIsCancel,
  setCancelItem,
  getList,
}: MyReservationListProps) => {
  const [selected, setSelected] = useState<UserReservationResponse | null>(
    null
  );
  const history = useHistory();

  const handleSelected = (item: UserReservationResponse) => {
    if (selected === item) {
      setSelected(null);
    } else {
      setSelected(item);
    }
  };

  const handleCancel = (item: UserReservationResponse) => {
    setIsCancel(true);
    setCancelItem(item);
  };

  const getReservationState = async () => {
    if (!selected) return;
    try {
      if (selected.pubType === "RUNNER") {
        const res = await getCompanyCurrentReservations(selected.reservationId);
        setCurrentList(
          res.map((item, index) => {
            return {
              order: res.length - index + "",
              customerName: item.nickname,
              id: item.id,
            };
          })
        );
      } else {
        const res = await getCurrentReservations(selected.reservationId);
        setCurrentList(
          res.map((item, index) => {
            return {
              order: res.length - index + "",
              customerName: item.nickname,
              id: 0,
            };
          })
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getReservationState();
  }, [selected]);

  const formatDate = (value: string) => {
    const [date, time] = value.split(" ");

    const [year, month, day] = date.split("-");
    const [hours, minutes] = time.split(":");

    if (+hours >= 12) {
      return `${year}.${month}.${day} 오후 ${
        +hours - 12 === 0 ? 12 : +hours - 12
      }시${minutes}분`;
    } else {
      return `${year}.${month}.${day} 오전 ${hours}시${minutes}분`;
    }
  };

  const handleTotalCapacity = (tournament: PubTournament) => {
    const totalCapacity =
      tournament.adOnUserCount +
      tournament.entryUserCount +
      tournament.reBuyInUserCount;

    return totalCapacity;
  };

  const formatPhoneNumber = (number: string) => {
    if (number.includes("-")) return number;

    const cleanNumber = number.replace(/\D/g, "");

    if (cleanNumber.length === 10) {
      return cleanNumber.replace(/^(\d{3})(\d{4})(\d{4})$/, "$1-$2-$3");
    } else if (cleanNumber.length === 11) {
      return cleanNumber.replace(/^(\d{3})(\d{4})(\d{4})$/, "$1-$2-$3");
    } else {
      return number;
    }
  };
  return (
    <MyReservationListWrapper>
      {list.map((item, index) => (
        <MyReservationListItem key={index} onClick={() => handleSelected(item)}>
          <div className="top">
            <div className="content">
              <div className="title">
                {item.pubName}
                {item.isCancel && " (취소된 예약)"}
              </div>
              <div className="date">{formatDate(item.startDate)}</div>
            </div>
            <div className="arrow">
              <img
                src={`image-web/reservation/${
                  selected === item ? "up" : "down"
                }-arrow.svg`}
                alt="arrow"
              />
            </div>
          </div>
          {selected === item && (
            <MyReservationListItemBottom>
              <div className="top">
                <img src={item.reservationImage} alt={item.tournamentName} />
                <div className="right">
                  <div
                    className="reservation-state"
                    onClick={(e) => {
                      e.stopPropagation();
                      setCurrentOpen(true);
                    }}
                  >
                    예약현황({item.reservationCount})
                  </div>
                  <div className="title">{item.tournamentName}</div>
                  <div className="info-wrapper">
                    <div className="info">
                      <span>번호 </span>
                      {formatPhoneNumber(item.pubPhoneNumber)}
                    </div>
                    <div className="info">
                      <span>주소 </span>
                      {item.pubAddress}
                    </div>
                  </div>
                </div>
              </div>
              <div className="button-wrapper">
                <div
                  className="button purple"
                  onClick={() =>
                    history.push(`/tournament/${item.tournamentId}`)
                  }
                >
                  현재 엔트리 {item.tournament.userCount}/
                  {handleTotalCapacity(item.tournament)}
                </div>
                <div
                  className="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!item.isCancel) handleCancel(item);
                  }}
                >
                  {item.isCancel ? "취소 완료" : "취소"}
                </div>
              </div>
            </MyReservationListItemBottom>
          )}
        </MyReservationListItem>
      ))}
    </MyReservationListWrapper>
  );
};

export default MyReservationList;
